import { ReactNode } from 'react'
import { Box, VStack } from '@chakra-ui/react'

// Make a wrapping react component that passes down background color as a prop
// to the PageSection component
interface PageSectionProps {
  backgroundColor?: string
  children: ReactNode
  isFillRemainingSpace?: boolean
}

export const PageSection = ({
  backgroundColor,
  children,
  isFillRemainingSpace = false,
}: PageSectionProps) => {
  return (
    <Box
      backgroundColor={backgroundColor}
      width="100%"
      paddingX={{ base: '55px', md: '75px', lg: '155px', xl: '255px' }}
      flexGrow={isFillRemainingSpace ? 1 : 0}
    >
      <VStack width="100%" maxW="1350px" marginLeft="auto" marginRight="auto">
        {children}
      </VStack>
    </Box>
  )
}
